import { featureIcons } from '@/components/Menu/featureicons';
import { getEnsureLoadedLoader } from './loaderHelper';

export const useLicencesLoader = (AddLoader: (loader: () => Promise<void>, key: string, icon?: string) => void) => {
    AddLoader(getEnsureLoadedLoader('Licences'), 'licences.loading_licences', 'fa-globe');
};
